import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, signal } from '@angular/core';
import { BehaviorSubject, timer } from "rxjs";

interface CustomWindow extends Window {
  userTheme?: "light" | "dark";
}

declare let window: CustomWindow;

@Injectable({
  providedIn: 'root'
})
export class AppService {

  userTheme$ = signal<boolean>(false);
  themeSignal = signal<string>('light');

  private _theme = new BehaviorSubject<'light' | 'dark'>('light');
  theme$ = this._theme.asObservable();

  themes = [
    { id: "mdc-light-indigo", label: "MDC Light Indigo" },
    { id: "mdc-dark-indigo", label: "MDC Dark Indigo" },
  ];

  constructor(@Inject(DOCUMENT) private document: Document) {

    // Load saved settings from local storage or create new.
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme !== null) {
      const theme = JSON.parse(savedTheme);
      if(theme) {
      }
      this.setTheme(theme);
    }
    else {
      localStorage.setItem('theme', JSON.stringify(this._theme.getValue()));
    }

    // Set theme when changed.
    this.theme$.subscribe((theme) => {
      if (theme === 'dark') {
        this.switchTheme(this.themes[1].id);
      }
      else {
        this.switchTheme(this.themes[0].id);
      }
    });
  }

  switchTheme(theme: string): void {
    let themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;

    if (themeLink) {
      themeLink.href = theme + '.css';
    }
  }
  initThemeWatcher(): void {
    timer(0, 500).subscribe(() => {
      if (window?.userTheme) {
        if (window.userTheme === 'light' && this._theme.getValue() === 'dark') {
          this.setTheme('light');
        } else if (
          window.userTheme === 'dark' &&
          this._theme.getValue() === 'light'
        ) {
          this.setTheme('dark');
        }
      }
    });
  }

  toggleTheme(): void {
    if (this._theme.getValue() === 'light') {
      this.setTheme('dark');
      this.themeSignal.set('dark');
    } else {
      this.setTheme('light');
      this.themeSignal.set('light');
    }
  }

  getTheme() {
    return this._theme.getValue();
  }

  setTheme(newTheme: 'light' | 'dark'): void {
    this._theme.next(newTheme);
    localStorage.setItem('theme', JSON.stringify(newTheme));
  }
}





